/* dede başlık: mega menü, mobil menü, yapışkan başlık. --header-offset/--hdr-h yazar.
   Dinleyiciler document'a bir kez bağlanır. */
(function () {
  if (window.__dedeNav) return;
  window.__dedeNav = 1;
  var D = document, R = D.documentElement, W = window, mq = matchMedia('(max-width: 900px)'),
    inerted = [], vars = {}, lastY = 0, raf = 0, tNav = 0,
    cur = null, how = '', openY = 0, tOpen = 0, tClose = 0, tReset = 0;
  var FOC = 'a[href],button:not([disabled]),input:not([type="hidden"]),[tabindex]:not([tabindex="-1"])';
  function H() { return D.querySelector('[data-header]'); }
  function all(s, r) { return [].slice.call((r || D).querySelectorAll(s)); }
  function foc(el) { if (el) el.focus({ preventScroll: true }); }
  function shown(el) { return el.getClientRects().length && !el.closest('[inert]') && getComputedStyle(el).visibility != 'hidden'; }
  function setVar(k, v) { if (vars[k] !== v) { vars[k] = v; R.style.setProperty(k, v); } }
  function kbFocus(h) { try { return !!h.querySelector(':focus-visible'); } catch (e) { return h.contains(D.activeElement); } }

  /* --- mega menü (masaüstü) --- */
  function trig(li) { return li.querySelector('[data-mega-trigger]'); }
  /* kapalı panel inert: solarken Tab içine düşmesin */
  function mark(li, on) { on = !!on; li.classList.toggle('is-open', on); li.querySelector('[data-mega]').inert = !on; trig(li).setAttribute('aria-expanded', on); }
  /* panel/örtü üst kenarı: başlık satırının altı (kaydırınca tazelenir) */
  function mtop(h) { h.style.setProperty('--mega-top', Math.round(h.querySelector('.site-header__inner').getBoundingClientRect().bottom) + 'px'); }
  function openMega(li, by) {
    clearTimeout(tOpen); clearTimeout(tClose);
    var h = H();
    if (!li || !h || mq.matches) return;
    if (cur === li) { if (by != 'hover') how = by; return; }
    h.classList.toggle('is-switch', !!cur);
    if (cur) mark(cur);
    mtop(h);
    cur = li; how = by; openY = W.pageYOffset;
    mark(li, true);
    h.classList.add('is-mega');
  }
  /* f: 0 = odak paneldeyse düğmeye döner · -1 = odağa dokunulmaz */
  function closeMega(f) {
    clearTimeout(tOpen); clearTimeout(tClose);
    if (!cur) return;
    var li = cur, t = trig(li), h = H(), a = D.activeElement;
    cur = null; mark(li);
    if (h) h.classList.remove('is-mega', 'is-switch');
    if (f === 0 && a !== t && li.contains(a)) foc(t);
  }

  /* --- mobil menü --- */
  function isOpen() { var h = H(); return !!h && h.classList.contains('is-open'); }
  function release() { inerted.splice(0).forEach(function (el) { el.inert = false; }); }
  function expand(li, on) {
    li.classList.toggle('is-open', on);
    li.querySelector('[data-mnav-toggle]').setAttribute('aria-expanded', on);
  }
  /* akordeon: tek madde açık kalır. li=null hepsini kapatır · instant: animasyonsuz · force: kesin açar (editör) */
  function sub(li, instant, force) {
    var m = D.querySelector('[data-mnav]');
    if (!m) return;
    var on = !!li && (force || !li.classList.contains('is-open'));
    if (instant) m.classList.add('is-instant');
    all('.mnav__item.is-open', m).forEach(function (o) { expand(o, false); });
    if (on) expand(li, true);
    if (instant) { void m.offsetWidth; m.classList.remove('is-instant'); }
  }
  function setOpen(on, noFocus) {
    var h = H();
    if (!h || on === isOpen()) return;
    var t = h.querySelector('[data-nav-toggle]'), d = h.querySelector('[data-nav-drawer]');
    clearTimeout(tReset);
    closeMega(-1);
    tNav = Date.now();
    h.classList.toggle('is-open', on);
    h.classList.remove('is-hidden');
    if (t) t.setAttribute('aria-expanded', on);
    R.classList.toggle('nav-lock', on);
    if (on) {
      sub(null, 1); /* hızlı kapat-aç: menü hep kapalı akordeonlarla açılır */
      all('body > *').forEach(function (el) {
        if (!el.contains(h) && !el.inert && el.tagName != 'SCRIPT') { el.inert = true; inerted.push(el); }
      });
      if (!noFocus) foc(d && d.querySelector(FOC));
    } else {
      release();
      tReset = setTimeout(function () { sub(null, 1); }, 320);
      if (!noFocus) foc(t);
    }
    paint();
  }
  function trap(e) {
    var h = H(), a = D.activeElement, els = all(FOC, h).filter(shown), first = els[0], last = els[els.length - 1];
    if (!first) return;
    if (e.shiftKey && (a === first || !h.contains(a))) { e.preventDefault(); foc(last); }
    else if (!e.shiftKey && (a === last || !h.contains(a))) { e.preventDefault(); foc(first); }
  }

  /* --- yapışkan başlık: telefonda aşağı kayınca gizlenir --- */
  function paint() {
    raf = 0;
    var h = H();
    if (!h) return;
    var y = Math.max(0, W.pageYOffset), hh = h.offsetHeight, hide = h.classList.contains('is-hidden');
    if (cur) { mtop(h); if (how != 'editor' && Math.abs(y - openY) > 60) closeMega(0); }
    h.classList.toggle('is-stuck', y > 2);
    /* menü aç/kapatta promo kaymasi "asagi kaydirma" sayilmaz */
    if (!mq.matches || isOpen() || y <= hh || Date.now() - tNav < 500) { hide = false; lastY = y; }
    else if (Math.abs(y - lastY) > 6) { hide = y > lastY && !kbFocus(h); lastY = y; }
    h.classList.toggle('is-hidden', hide);
    setVar('--hdr-h', hh + 'px');
    setVar('--header-offset', mq.matches && !hide ? hh + 'px' : '0px');
  }
  function queue() { if (!raf) raf = requestAnimationFrame(paint); }

  /* --- olaylar --- */
  D.addEventListener('click', function (e) {
    var el = e.target, h = H();
    if (!h || !el.closest) return;
    if (el.closest('[data-nav-toggle]')) { setOpen(!isOpen()); return; }
    /* aç/kapat sırasında başlık kayar: hemen sonraki dokunuş yanlış bağlantıyı açmasın */
    if (Date.now() - tNav < 260 && el.closest('.site-header__drawer,[data-promo-bar]')) { e.preventDefault(); return; }
    var b = el.closest('[data-mnav-toggle]');
    if (b) { sub(b.parentNode); return; }
    if (isOpen() && el.closest('.site-header__drawer a[href], [data-cart-link]')) setOpen(false, 1);
    var tb = el.closest('[data-mega-trigger]');
    if (tb) {
      var li = tb.closest('.hnav__item');
      /* fareyle açılmış paneli tıklamak kapatmaz, sabitler */
      if (cur === li && !(how == 'hover' && e.detail)) closeMega(-1);
      else openMega(li, 'click');
      return;
    }
    if (cur && (!cur.contains(el) || el.closest('a[href]'))) closeMega(-1);
  });
  D.addEventListener('keydown', function (e) {
    var k = e.key;
    if (isOpen()) {
      if (k == 'Escape') setOpen(false);
      else if (k == 'Tab') trap(e);
      return;
    }
    if (k == 'Escape' && cur) { closeMega(0); return; }
    var tb = k == 'ArrowDown' && e.target.closest && e.target.closest('[data-mega-trigger]');
    if (tb) {
      e.preventDefault();
      var li = tb.closest('.hnav__item');
      openMega(li, 'click');
      foc(li.querySelector('.mega a[href]'));
    }
  });
  D.addEventListener('focusin', function (e) {
    var h = H();
    if (h && h.contains(e.target)) h.classList.remove('is-hidden');
    if (cur && !cur.contains(e.target)) closeMega(-1);
  });
  /* fare: kısa beklemeyle açılır; başlığın her yeri paneli açık tutar (tetikle panel arası boşluk dahil) */
  D.addEventListener('pointerover', function (e) {
    if (e.pointerType != 'mouse' || mq.matches || !e.target.closest) return;
    var h = H(), li = e.target.closest('.hnav__item');
    if (!h || !h.contains(e.target)) return;
    clearTimeout(tClose);
    if (!li || li === cur) return;
    clearTimeout(tOpen);
    if (li.querySelector('[data-mega]')) tOpen = setTimeout(function () { openMega(li, 'hover'); }, cur ? 90 : 150);
    else if (cur && how == 'hover') tClose = setTimeout(function () { closeMega(0); }, 200);
  });
  D.addEventListener('pointerout', function (e) {
    if (e.pointerType != 'mouse' || !e.target.closest) return;
    var h = H(), to = e.relatedTarget, li = e.target.closest('.hnav__item');
    if (li && !(to && li.contains(to))) clearTimeout(tOpen);
    if (h && cur && how == 'hover' && !(to && h.contains(to))) { clearTimeout(tClose); tClose = setTimeout(function () { closeMega(0); }, 400); }
  });
  (mq.addEventListener ? mq.addEventListener.bind(mq, 'change') : mq.addListener.bind(mq))(function () {
    if (!mq.matches) setOpen(false, 1);
    closeMega(-1); queue();
  });
  addEventListener('scroll', queue, { passive: true });
  addEventListener('resize', queue);
  addEventListener('pageshow', function () { closeMega(-1); if (!isOpen()) { release(); R.classList.remove('nav-lock'); } queue(); });

  /* --- editör: "Menü görseli" seçilince panel açılır --- */
  function card(e) {
    var h = H(), id = e.detail && e.detail.blockId;
    return h && id ? h.querySelector((mq.matches ? '.mnav' : '.mega') + ' [data-mcard="' + id + '"]') : null;
  }
  D.addEventListener('shopify:block:select', function (e) {
    var c = card(e);
    if (!c) return;
    if (mq.matches) { setOpen(true, 1); sub(c.closest('.mnav__item'), 1, 1); }
    else { openMega(c.closest('.hnav__item'), 'editor'); how = 'editor'; }
    requestAnimationFrame(function () { c.scrollIntoView({ block: 'nearest' }); });
  });
  D.addEventListener('shopify:block:deselect', function (e) {
    if (card(e)) { closeMega(-1); setOpen(false, 1); }
  });
  function reset() {
    clearTimeout(tOpen); clearTimeout(tClose); clearTimeout(tReset);
    cur = null; release(); R.classList.remove('nav-lock');
  }
  D.addEventListener('shopify:section:unload', function (e) {
    if (e.target.querySelector('[data-header]')) { closeMega(-1); reset(); }
  });
  D.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('[data-header]')) { reset(); queue(); }
  });
  paint();
})();
